import React, { memo, SyntheticEvent, useEffect, useState } from 'react'
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Typography from 'components/Typography'
import { PropsContentSnackbar } from './types'
import { Snackbar, Alert } from './styles'

function PopUpSnackbar() {
  const [contentSnackbar, setContentSnackbar] = useState<PropsContentSnackbar | null>()

  const displaySnackbar = (event: CustomEvent<PropsContentSnackbar>) => {
    setContentSnackbar(event.detail)
  }

  const closeSnackbar = (_: Event | SyntheticEvent<unknown, Event>, reason?: string) => {
    if (reason === 'clickaway') return
    setContentSnackbar(null)
  }

  useEffect(() => {
    window.addEventListener('show-snackbar', displaySnackbar as EventListener)
    return () => {
      window.removeEventListener('show-snackbar', displaySnackbar as EventListener)
    }
  }, [])

  if (!contentSnackbar) {
    return null
  }

  return (
    <Snackbar
      open
      onClose={closeSnackbar}
      autoHideDuration={8000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        variant="filled"
        data-testid="container-snackbar"
        onClose={closeSnackbar}
        severity={contentSnackbar.type}
        iconMapping={{
          success: <CheckCircleIcon />,
          error: <ErrorOutlinedIcon />,
        }}
      >
        <Typography fontWeight="500" fontSize="14px" color="white">
          {contentSnackbar?.message}
        </Typography>
      </Alert>
    </Snackbar>
  )
}

export default memo(PopUpSnackbar)
